import * as ko from 'knockout'
import NoveltyDividend from '@classic/Betting-v2/Model/NoveltyDividend'
import template from './novelty.dividends.tpl.html'
import { NoveltyDividendsViewModel } from './NoveltyDividendsViewModel'

interface Params {
  noveltyDividends: ko.ObservableArray<NoveltyDividend>
}

if (!ko.components.isRegistered('novelty-dividends')) {
  ko.components.register('novelty-dividends', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new NoveltyDividendsViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
